import _extends from "@babel/runtime/helpers/extends";
import { List, Paper } from '@material-ui/core';
import React from 'react';
/**
 * Default container for Reference Field suggestion list
 * @param options
 */
export const ReferenceFieldContainer = options => /*#__PURE__*/React.createElement(Paper, {
  square: true,
  style: {
    position: 'fixed',
    zIndex: 1
  }
}, /*#__PURE__*/React.createElement(List, _extends({
  component: "nav"
}, options.containerProps, {
  style: {
    padding: 0
  }
}), options.children));
//# sourceMappingURL=ReferenceFieldContainer.js.map